import StandardConfirmationModal from "../standard-confirmation";
import { FC } from "react";

interface RestrictUserModalProps extends StandardModalProps {
  onConfirm: () => void;
  name?: string;
  loading: boolean;
  description?: string;
}

const RestrictUserModal: FC<RestrictUserModalProps> = ({
  open,
  onClose,
  onConfirm,
  name,
  loading,
  description,
}) => {
  return (
    <StandardConfirmationModal
      open={open}
      onClose={onClose}
      maxWidth="xs"
      onConfirm={onConfirm}
      title={`Restrict "${name}"`}
      description={`Are you sure you want to restrict this ${description}? This action cannot be undone.`}
      confirmButtonColor="error"
      confirmButtonTitle="Restrict"
      confirmButtonLoader={loading}
    />
  );
};

export default RestrictUserModal;
